import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import type { MenuOptionType } from "../../../../../controls";
import type { EmailAddress } from "../../../emailTopics/models/EmailAddress";

type Props = {
	newEmailAddress: () => void;
	editEmailAddress: (address: EmailAddress) => void;
	deleteEmailAddress: (address: EmailAddress) => void;
};

export const useEmailAddressesOptionsFunctions = ({
	newEmailAddress,
	editEmailAddress,
	deleteEmailAddress,
}: Props) => {
	const getMenuOptions = (data?: EmailAddress) => {
		let options: MenuOptionType[] = [
			{
				name: "New Email Address",
				key: "new_email_address",
				onClick: () => {
					newEmailAddress();
				},
				icon: <EditIcon />,
			},
		];

		if (!data) {
			return options;
		}

		options = options.concat([
			{
				name: "Edit Email Address",
				key: "edit_email_address",
				onClick: () => {
					editEmailAddress(data);
				},
				icon: <EditIcon />,
			},
			{
				name: "Delete Email Address",
				key: "delete_email_address",
				onClick: () => {
					deleteEmailAddress(data);
				},
				icon: <DeleteIcon />,
			},
		]);

		return options;
	};

	return { getMenuOptions };
};
